import { Utils } from 'versafleet-core';

const { RequestHelper: { request } } = Utils;

function receiveCustomLayout(customLayout) {
  return {
    type: 'RECEIVE_CUSTOM_LAYOUT',
    customLayout,
  };
}

function fetch() {
  return async (dispatch) => {
    const result = await request('/custom_layout', {
      method: 'GET',
    });
    dispatch(receiveCustomLayout(result.custom_layout));
    return result.custom_layout;
  };
}

export default {
  fetch,
};
